export const LANGUAGE_ROUTES = ['nl', 'nl_en', 'de', 'de_en'];

export function isLanguageRoute(pathname: string): boolean {
  const match = /^\/([^/]+)\/?$/.exec(pathname);
  return match !== null && LANGUAGE_ROUTES.includes(match[1]);
}

export function countryFromPath(pathname: string): string {
  const lang = pathname.split('/')[1] ?? '';
  if (lang.startsWith('nl')) return 'nl';
  if (lang.startsWith('de')) return 'de';
  return '';
}
